export const producersSortArray = ['amatic', 'Evolution Gaming', 'pragmaticplaylive', 'pragmaticplay', 'Sport']
export const excludeProducersArray = ['bcraft', 'evolution', 'pragmaticexternal', 'pragmatic']

export const intergrationsExcludeArray = ['89fa86ca']

export const renameProducerForBetshistory: Record<string, string> = {
  evosw: 'Evolution Gaming',
  egtinteractive: 'amusnet',
}

export const changeProducerBeforeSend = (producer: string) => {
  switch (producer) {
    case 'all':
      return undefined
    default:
      return producer
  }
}
